module.exports = __webpack_public_path__ + "static/media/12.394a978f.jpg";